import {useCallback} from "react";

export const filterAvailable = <T extends {isAvailable: boolean}, >(elements: T[]) =>
  elements.filter(element => element.isAvailable)

export const useFilterAvailable = () => useCallback(<T extends {isAvailable: boolean}, >(elements: T[]) => {
  return filterAvailable(elements)
}, [])